/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CurrencyTypeEnum {
    Fiat = 10,
    Crypto = 20,
}
